import React, { useEffect, useState } from 'react';
import { ThemeProvider } from './context/ThemeContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Projects from './components/Projects';
import Skills from './components/Skills';
import Experience from './components/Experience';
import Education from './components/Education';
import Resume from './components/Resume';
import Contact from './components/Contact';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';

const PAGE_BY_HASH = {
  '#/privacy': 'privacy',
  '#/terms': 'terms',
};

function App() {
  const [currentPage, setCurrentPage] = useState('home');

  useEffect(() => {
    const handleHashChange = () => {
      setCurrentPage(PAGE_BY_HASH[window.location.hash] || 'home');
    };
    handleHashChange();
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  // Hash-based navigation to /privacy or /terms doesn't match any element id,
  // so the browser leaves scroll position untouched instead of resetting it,
  // landing users wherever they were on the page they navigated from (often
  // the bottom, since these links live in the Footer).
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);

  if (currentPage === 'privacy') return <PrivacyPolicy />;
  if (currentPage === 'terms') return <TermsOfService />;
  return (
    <ThemeProvider>
      <div>
        <Navbar />
        <Hero />
        <Projects />
        <Experience />
        <Skills />
        <Education />
        <Resume />
        <Contact />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default App;
